import { z } from 'zod';

export const coeVendorSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string(),
  tagName: z.string(),
  tagColor: z.string(),
  tagIcon: z.string(),
  phoneNumber: z.string(),
  website: z.string(),
});

export type CoeVendor = z.infer<typeof coeVendorSchema>;

export const coeProgramSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string(),
  isMandatory: z.boolean(),
  vendorId: coeVendorSchema.shape.id,
  specialties: z.array(z.number()),
  subspecialties: z.array(z.number()),
});

export type CoeProgram = z.infer<typeof coeProgramSchema>;

// COE data on provider or place document
export const resultCoeVendorSchema = z.object({
  coeVendorId: z.number(),
  coeVendorName: z.string(),
});

export type ResultCoeVendor = z.infer<typeof resultCoeVendorSchema>;

export const resultCoeProgramSchema = z.object({
  coeProgramId: z.number(),
  coeProgramName: z.string(),
});

export type ResultCoeProgram = z.infer<typeof resultCoeProgramSchema>;
